import { createFileRoute } from "@tanstack/react-router";
import WhatIsSaintTmsPage from "@/pages/learn/WhatIsSaintTmsPage";
import { page1 } from "@/pages/learn/learnDataP1";
import { buildHreflang } from "@/lib/i18n/locale";

const TITLE = "What Is SAINT\u00ae TMS? The 5-Day Stanford-Developed Treatment";
const DESC =
  "SAINT\u00ae (Stanford Accelerated Intelligent Neuromodulation Therapy, also called SNT) explained: how the fMRI-guided 5-day TMS works, results, safety, cost.";
const URL = "https://neurowellnesstms.com/learn/what-is-saint-tms";

export const Route = createFileRoute("/learn/what-is-saint-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { title: TITLE },
        { name: "description", content: DESC },
        { property: "og:title", content: TITLE },
        { property: "og:description", content: DESC },
        { property: "og:url", content: URL },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [
        { rel: "canonical", href: URL },
        ...buildHreflang("/learn/what-is-saint-tms"),
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page1.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsSaintTmsPage />;
}
